module.exports = __webpack_public_path__ + "img/22.c2c36672.png";